import api from "./api";

export async function connectPetpooja(outletUid) {

    const response = await api.post(

        "/api/v1/petpooja/connect",

        {
            outletUid,
        }

    );

    return response.data;

}